export default {
  'Animate old photos': 'Alte Fotos animieren',
  'Animate faces in your photos with AI technology, create vivid videos.':
    'Gesichter Animieren in Ihren Fotos mit KI-Technologie und lebendige Videos erstellen.',
  'Upload a photo': 'Ein Foto hochladen',
  'please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.':
    'Hinweis: Stellen Sie sicher, dass das Gesicht auf den von Ihnen ausgewählten Fotos zum Objektiv zeigt, da es sonst nicht erfolgreich verarbeitet werden kann.',
  'Uploaded successfully!': 'Hochgeladen erforgreich!',
  'Please select a template below': 'Bitte wählen Sie unten eine Vorlage aus',
  'Choose a GIF': 'Ein GIF wählen',
  'Use this template': 'Diese Vorlage verwanden',
  'Verify successfully! You will':
    'Verifikation ist erfolgreich! Das Video wird bald über {{email}} gesendet.',
  'You will': 'Das Video wird bald über {{email}} gesendet.',
  'What you should expect to happen next':
    'Was Sie als nächstes erwarten sollten:',
  'We will process your photo into a dynamic video.':
    'Wir verarbeiten Ihr Foto zu einem dynamischen Video.',
  'After processing, we will send the video to your email.':
    'Nach der Bearbeitung senden wir das Video an Ihre E-Mail.',
  'You can check the video in your email.':
    'Sie können das Video in Ihrer E-Mail überprüfen.',
  'Your video will be delivered via email':
    'Ihr Video wird per E-Mail geliefert.',
  'It takes 20-30 minutes to synthesize a dynamic video, please be patient. To protect your privacy, the uploaded pictures will be automatically deleted after the processing is over.':
    'Die Synthese des dynamischen Videos dauert 20 bis 30 Minuten. Bitte haben Sie etwas Geduld. Um Ihre Privatsphäre zu schützen, werden die hochgeladenen Bilder nach Abschluss der Verarbeitung automatisch gelöscht.',
  'Your Email': 'Ihre E-Mail',
  'Last Name': 'Nachname',
  'First Name': 'Vorname',
  'Go back': 'Zurückgehen',
  'Invalid email address': 'Ungültige E-Mail-Adresse',
  'Enter verification code': 'Verifizierungscode eingeben',
  'Enter the verification code that we sent to':
    'Verifizierungscode eingeben, den wir an {{email}} gesendet haben.',
  Resend: 'Erneut senden',
  'Verification code': 'Verifizierungscode',
  'Resend after': 'in {{num}}s erneut senden',
  'The verification code is invalid. You can request a new one.':
    'Der Verifizierungscode ist ungültig. Sie können einen neuen anfordern.',
  'Synthesize Video': 'Video synthetisieren',
  Next: 'Weiter',
  'Too many attempts, please try again later.': '请求频繁，请稍后再试。',
  'xx people is waitting in front of you to generate image.':
    ' creators ahead of you, please wait...',
  'Animating...': 'Animating...',
  'You are in line...': 'You are in line...',
  'Failed to generate, click to retry.': 'Failed to generate, click to retry.',
  'The processing will be completed soon, are you sure you want to cancel it?':
    'The processing will be completed soon, are you sure you want to cancel it?',
  freeAccountExceed: 'The image size cannot exceed 2MB in free version.',
  freeAccountHD: 'Upgrade to download HD watermark-free images.',
  UpgradeToDownloadAsGIF: 'Upgrade to download video as GIF.',
  UpgradeToUploadLimits: 'Upgrade to unlimited image uploads.',
  DynamicTitle: 'HitPaw Online Animate Old Photos',
  SizeLimit: 'No Image Size Limits',
  UploadLimit: 'Unlimited Image Uploads',
  DownloadNoWaterMark: 'Download HD Image with No Watermark',
  DownloadGIF: 'Download Video as GIF',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  priceWeek: '$3.99',
  priceMonth: '$1.99',
  priceYear: '$0.99',
  Week: 'Week',
  billMonth: '$7.99 Billed Monthly',
  billYear: '$47.99 Billed Annually',
};
